export default __webpack_public_path__ + "static/nextGenerationMechanicalPlxusMobile-a8880f7f33779f7295cd7ddd4d76054a.png";